module.exports = __webpack_public_path__ + "img/avat2.4886831b.png";